import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const uniqueVoucherCampaignListRolesRBAC = {
  pageID: '49f925e36b08dae67c63d89094d8fd5c',
  elementID: {
    ViewCampaign: '1a14aac90723e079c106bf48ab232e4a',
    EditCampaign: '6c79fff829c9b729c9df106771b55bb4',
    DownloadCampaign: '102ecbb29da95660a53694384da62188',
    CreateCampaign: '7b02477867ebb04cb6ba9ab06c5e2e3e',
  },
} as const

export const useRBACUniqueVoucherCampaignListPage = createUseRBAC(
  uniqueVoucherCampaignListRolesRBAC.elementID,
)

export type UseRBACUniqueVoucherCampaignListPageType = ReturnType<
  typeof useRBACUniqueVoucherCampaignListPage
>
